import React, { useState } from 'react';

const GoalModal = ({setActive, fireAmplitude, ampEventType, createAuthorsHubSelection}) => {

  const [goal, setGoal] = useState('')

  const handleClick = () => {
    setActive(goal)
    fireAmplitude(ampEventType, {selection: goal})
    createAuthorsHubSelection(goal)
  }

  return (
    <div id={"choose-your-goal-modal"} className="reveal-modal new-modal middling" data-reveal>
      <div className="modal-body">
        <div className="modal-close">
          <a href='#' className='cancel-modal'>
            <img src="https://public.cureus.com/close_x.png"/>
          </a>
        </div>
        <div className="modal-content">
          <div className="row">
            <div className="large-12 columns text-center">
              <img src="https://public.cureus.com/authors-hub/goal-modal-img.png" />
            </div>
            <div className="large-12 columns text-center">
              <h4>Choose your goal</h4>
              <p>We’re glad to have you onboard. Here are some quick tips to get you up and running.</p>
            </div>
            <textarea onChange={(e) => setGoal(e.target.value)}/>
          </div>
          <div className="modal-footer text-center">
            <a href="#" className="cancel-modal button secondary">Skip</a>
            <a className="button cancel-modal" onClick={handleClick}>Submit</a>
          </div>
        </div>
      </div>
    </div>
  )
}

export default GoalModal;